<template>
    <modal :name="name" :adaptive="true" height="auto" @before-open="beforeOpen" >
        <div class="ut-p-6 md:ut-p-12">
            <div class="modal-header">

                <div class="ut-flex">
                    <div class="ut-w-4/5 ut-text-2xl ut-font-bold ut-mx-0">
                        <slot name="header">
                            <!--<img class="ut-mr-4" src="@/assets/images/tick.svg"/>-->
                            <!--<span>Close lead</span>-->
                        </slot>
                    </div>
                    <div @click="closeModal" class="ut-flex ut-m-0 ut-justify-end ut-w-1/5 ">
                        <img class=" ut-mx-0 ut-cursor-pointer"
                             src="@/assets/images/close.svg"/>
                    </div>

                </div>
                <div v-if="!!$slots.description" class="ut-flex">
                    <div class="ut-my-6 ut-text-sm ">
                        <slot name="description">
                            <!--You are closing Artem in Waterloo.-->
                            <!--This will remove it from your list.-->
                            <!--Please provide a reason for closing this lead.-->
                        </slot>
                    </div>
                </div>
                <span></span>
            </div>

            <div class="modal-body">
                <div class="ut-my-6 ut-m-0">
                    <slot name="body">
                        <!--<div>-->
                        <!--Reason for closing lead-->
                        <!--</div>-->
                    </slot>
                </div>
            </div>

            <div class="modal-error">
                <slot name="error">
                    <!--error-->
                </slot>
            </div>

            <div class="modal-footer">
                <slot name="footer">
                    <!--footer-->
                </slot>
            </div>


        </div>
    </modal>
</template>

<script>
export default {
  name: 'OaModal',
  props: {
    name: {
      required: true,
    },
    show: {
      default: false,
    },
  },
  methods: {
    beforeOpen(event) {
      if (!!event && !!event.params) {
        this.$emit('before-open', event);
      }
    },
    closeModal() {
      this.$modal.hide(this.name);
    },
  },
};
</script>
